module.exports = __webpack_public_path__ + "img/aviato.e2bd63eb.png";